
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3677F6","d":"M66.674 10H13.326A3.336 3.336 0 0010 13.326V35.41a3.336 3.336 0 003.326 3.326h53.348A3.335 3.335 0 0070 35.41V13.326A3.314 3.314 0 0066.674 10z"}}),_c('path',{attrs:{"fill":"#BFD8FB","d":"M25.831 43.658H13.326A3.336 3.336 0 0010 46.984v19.69A3.336 3.336 0 0013.326 70H25.83a3.336 3.336 0 003.326-3.326v-19.69a3.336 3.336 0 00-3.326-3.326z"}}),_c('path',{attrs:{"fill":"#70A0FF","d":"M66.674 43.658H38.238a3.336 3.336 0 00-3.326 3.326v19.69A3.335 3.335 0 0038.238 70h28.436A3.336 3.336 0 0070 66.674v-19.69a3.314 3.314 0 00-3.326-3.326z"}})])
          )
        }
      }
    